module.exports = __webpack_public_path__ + "static/logo-0114adc1a283d2f05037055cd9119839.svg";